// src/pages/regulations/regulations.js
import React from "react";
import SidebarLayout from "../../components/sidebarLayout";
import Footer from "../../components/footer";
import NavigationBar from "../../components/navbar";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import { Accordion, Card } from "react-bootstrap";

export default function Regulations() {
  const regulationsMenu = menuData.find((menu) => menu.title === "포럼소개");

  return (
    <div>
      <SidebarLayout menu={regulationsMenu}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>제 1 조 (명칭)</Accordion.Header>
            <Accordion.Body>
              이 법인은 “ 사단법인 한국관광산업포럼(KTIRF :Korea Tourism
              Industry Research Forum)” (이하 ‘본원’이라 함)이라 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>제 2 조 (소재지)</Accordion.Header>
            <Accordion.Body>
              본원의 주된 사무소는 서울특별시에 두며, 필요에 따라 분원을 설치할
              수 있다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>제 3 조 (목적)</Accordion.Header>
            <Accordion.Body>
              관광산업 분야의 학문적 연구와 실무연구를 통하여 관광경영학을
              실용학문으로 정착하며 산학협력을 통하여 관광산업 발전과 관광정책의
              대안을 제시함을 목적으로 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>제 4 조 (사업)</Accordion.Header>
            <Accordion.Body>
              본원은 제3조의 목적을 달성하기 위하여 다음 각호의 사업을 수행한다.
              <br></br>
              1. 저서 출판<br></br> 2. 연구지발간<br></br> 3. 학술 세미나 개최
              <br></br>
              4. 장학사업<br></br> 5. 프로젝트사업<br></br> 6. 관광전문가 양성
              교육<br></br> 7. 관광 관련 업체 취업센터 운영<br></br> 8. 회원
              간의 지속적 학술 교환<br></br> 9. 기타 연구원의 목적에 부합하는
              사업<br></br> 10. 위 각호에 관련된 부대사업
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>제 5 조 (수익사업)</Accordion.Header>
            <Accordion.Body>
              1. 본원은 제4조에 규정한 목적 사업의 경비를 충당하기 위하여 필요한
              때는 그 본질에 반하 지 아니하는 범위 안에서 이사회의 의결을 거쳐
              수익사업을 할 수 있다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>제 6 조 (이익의 제공)</Accordion.Header>
            <Accordion.Body>
              1. 본원은 제4조에 규정한 목적사업을 수행함에 있어서 수혜자에게
              제공하는 이익은 무상으로 하며, 수혜자에게 그 대가의 일부를
              부담시킬 때에는 미리 이사회의 의결을 거쳐야 한다.<br></br> 2.
              본원의 목적사업으로 제공하는 이익은 특별히 그 목적을 한정한 경우를
              제외하고는 수혜자의 출생지, 출생학교, 직업, 성별, 기타 사회적 지위
              등에 의하여 부당하게 차별되어서는 안 된다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>제 7 조 (회원의 자격 및 종류)</Accordion.Header>
            <Accordion.Body>
              본원의 회원은 본원의 설립 취지에 동의하고 소정의 입회 신청서를
              제출한 자로 하며 회원자격 종류는 다음과 같다.<br></br> 1. (정회원)
              정회원은 국내·외에서 정규대학을 졸업하고 관광 연구 또는 기타 관광
              관련분야에 종사하는 자 및 이와 동등한 자격을 가졌다고 이사회가
              인정하는 내·외국인으로 한다.<br></br> 2. (준회원) 제7조 1항의 조건
              외의 관광에 관심이 많은 자로 한다.<br></br> 3. (단체회원) 본원의
              목적에 동의하고 본원의 활동과 발전을 위해 적극적으로 후원하는 법인
              또는 단체로 한다.<br></br> 4. (특별회원) 관광산업 진흥과 포럼
              발전을 위해 필요하다고 판단되는 정부 및 지자체 산하 기관 및
              투자기관·단체, 관광관련 기관·단체·업체, 포럼과 회원의 이익 도모에
              부합하는 자, 이와 유사한 성질의 법인(외국법인 포함) 및 개인(외국인
              포함)사업자 중 이사회의결에 의해 특별회원을 둘 수 있다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>제 8 조 (회원의 권리)</Accordion.Header>
            <Accordion.Body>
              회원은 총회를 통하여 본원의 운영에 참여할 권리를 가진다. 다만,
              준회원과 단체회원, 특별회원은 총회에 출석하여 발언 할 수 있으나
              의결권은 가질 수 없다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="8">
            <Accordion.Header>제 9 조 (회원의 의무)</Accordion.Header>
            <Accordion.Body>
              1. 본원의 정관 및 제 규약의 준수<br></br> 2. 총회 및 이사회의
              결의사항 이행<br></br>
              3. 회비 및 제 부담금의 납부<br></br> 법인의 회비는 정회원비,
              단체회원비, 특별회원비, 찬조회비로 하며, 회원은 년1회 이사회에서
              정하는 소정의 회비를 납부토록 한다. 그 외 회비와 관련된 사항은
              이사회에서 정할 수 있다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="9">
            <Accordion.Header>제 10 조 (회원의 탈퇴)</Accordion.Header>
            <Accordion.Body>
              회원은 원장에게 탈퇴서를 제출함으로써 자유롭게 탈퇴할 수 있다. 이
              경우 이미 납부한 회비는 반환하지 아니한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="10">
            <Accordion.Header>제 11 조 (회원의 상벌)</Accordion.Header>
            <Accordion.Body>
              1. 본원의 회원으로서 본원의 발전에 기여한 자에 대해서는 이사회의
              의결을 거쳐 포상할 수 있다.<br></br> 2. 본원의 회원으로서 본원의
              목적에 위배되는 행위 또는 명예와 위신에 손상을 가져오는 행위를
              하거나 제9조의 의무를 이행하지 아니한 자에 대하여는 이사회의
              의결을 거쳐 경고, 제명 등의 징계를 할 수 있다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="11">
            <Accordion.Header>제 12 조 (임원의 종류와 정수)</Accordion.Header>
            <Accordion.Body>
              본원은 다음의 임원을 둔다.<br></br> 1. 이사장 1인<br></br> 2. 원
              장 1인<br></br> 3. 부원장 10인 이내<br></br>4. 이사는 20인 이내로
              구성하도록 한다. (이사장, 원장 등을 포함한다.)<br></br>5. 감사는
              2인으로 한다. (단, 이사회의 추천을 받아 관광, 회계 등에 관한
              학식과 경험이 있는 전문가로 선임한다.)
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="12">
            <Accordion.Header>제 13 조 (임원의 선임)</Accordion.Header>
            <Accordion.Body>
              1. 임원은 총회에서 선출한다.<br></br> 2. 임원의 보선은 결원이
              발생한 날로부터 2월 이내에 하여야 한다.<br></br> 3. 새로운 임원의
              선출은 임기만료 2월 전까지 하여야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="13">
            <Accordion.Header>제 14 조 (임원의 해임)</Accordion.Header>
            <Accordion.Body>
              임원이 다음 각 호의 1에 해당하는 행위를 한 때에는 총회의 의결을
              거쳐 해임 할 수 있다.<br></br> 1. 본원의 목적에 위배되는 행위
              <br></br> 2. 임원 간의 분쟁, 회계부정 또는 현저한 부당행위
              <br></br> 3. 본원의 업무를 방해하는 행위
            </Accordion.Body>
          </Accordion.Item>

          {/* <Accordion.Item eventKey="14">
            <Accordion.Header>제 15 조 (임원의 선임 제한)</Accordion.Header>
            <Accordion.Body>
              1. 임원의 선임에 있어서 이사는 이사 상호간의 민법 제 777조에
              규정된 친족관계에 있는 자가 이사정수의 반을 초과할 수 없다.
              <br></br> 2. 감사는 감사 상호간 또는 이사와 민법 제 777조에 규정된
              친족 관계가 없어야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="15">
            <Accordion.Header>제 16 조 (상임이사)</Accordion.Header>
            <Accordion.Body>
              1. 본원의 목적사업을 전담하기 위하여 상임이사를 둘 수 있다.
              <br></br> 2. 상임이사는 이사회의 의결을 거쳐 이사장이 이사 중에서
              선임한다.
            </Accordion.Body>
          </Accordion.Item> */}

          <Accordion.Item eventKey="16">
            <Accordion.Header>제 17 조 (임원의 임기)</Accordion.Header>
            <Accordion.Body>
              1. 임원의 임기는 3년으로 재임할 수 있다.<br></br>2. 감사의 임기는
              3년으로 하되 1회에 한하여 연임할 수 있다.<br></br> 3. 보선에
              의하여 취임한 임원의 임기는 전임자의 잔여기간으로 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="15">
            <Accordion.Header>제 18 조 (임원의 직무)</Accordion.Header>
            <Accordion.Body>
              1. 이사장은 본원을 대표하고 본원의 업무를 통할하며, 총회 및
              이사회의 의장이 된다.<br></br> 2. 원장은 이사장을 보좌하며 본원의
              운영업무를 총괄한다.<br></br> 3. 이사는 이사회에 출석하여 본원의
              업무에 관한 사항을 의결하며 이사회 또는 이사장으로부터 위임받은
              사항을 처리한다.<br></br> 4. 감사는 다음의 업무를 행한다.<br></br>{" "}
              ⓵ 본원의 재산상황을 감사하는 일<br></br> ⓶ 총회 및 이사회의 운영과
              그 업무에 관한 사항을 감사하는 일<br></br> ⓷ 제⓵호 및 제⓶호의 감사
              결과 부정 또는 부당한 점이 있음을 발견한 때에는 이사회 또는 총회에
              그 시정을 요구하고 문화체육관광부장관에게 보고하는 일<br></br> ⓸
              제⓷호의 보고를 하기 위하여 필요한 때에는 총회 또는 이사회의 소집을
              요구하는 일<br></br> ⓹ 총회나 이사회에 출석하여 의견을 진술하는 일
              <br></br>
              5. 사무총장은 상위의 임원을 보좌하며 사무국의 운영 일체를
              총괄한다.<br></br> 6. 사무국장은 사무총장을 보좌하며 제반 실무를
              수행한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="18">
            <Accordion.Header>제 19 조 (임원의 직무대행)</Accordion.Header>
            <Accordion.Body>
              1. 이사장의 사고가 있을 때에는 원장이 이사장의 직무를 대행한다.
              <br></br> 2. 원장이 궐위되었을 때에는 부원장 중 연장자순으로
              직무를 대행한다.<br></br> 3. 제1항, 제2항의 규정에 의하여 직무를
              대행하는 자는 지체없이 선출의 절차를 밟아야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="19">
            <Accordion.Header>제 20 조 (고문과 자문위원)</Accordion.Header>
            <Accordion.Body>
              본원은 다음과 같이 고문과 자문위원을 추대할 수 있다.<br></br> 1.
              이사장은 본원의 발전에 현저한 공이 있으며 학식과 덕망이 있는 자를
              운영위원회에 추천하여 재적 이사 과반수의 의결로 위촉할 수 있으며
              해촉 시에도 동일한 절차를 밟는다.<br></br> 2. 고문과 자문위원의
              임기는 이사장의 임기로 하며 선임된 고문과 자문위원은 본원 활동과
              행사에서 적절한 예우를 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="20">
            <Accordion.Header>제 21 조 (총회의 구성)</Accordion.Header>
            <Accordion.Body>
              1. 총회는 본원의 최고 의결기관이며 회원으로 구성된다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="21">
            <Accordion.Header>제 22 조 (구분 및 소집)</Accordion.Header>
            <Accordion.Body>
              1. 총회는 정기총회와 임시총회로 구분한다.<br></br> 2. 정기총회는
              매 회계연도 개시 1월 전까지 소집하며, 임시총회는 이사장이
              필요하다고 인정할 때에 소집된다.<br></br> 3. 총회의 소집은
              이사장이 안건, 일시, 장소 등을 명기하여 회의 개시 7일 전까지
              문서로 회원에게 통보하여야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="22">
            <Accordion.Header>제 23 조 (총회소집의 특례)</Accordion.Header>
            <Accordion.Body>
              1. 이사장은 다음 각 호의 1에 해당하는 소집요구가 있을 때는 그
              소집요구일로부터 20일 이내에 총회를 소집하여야 한다.<br></br> ⓵
              재적이사 과반수가 회의의 목적을 제시하여 소집을 요구할 때<br></br>{" "}
              ⓶ 제18조 제3항 제4호의 규정에 의하여 감사가 소집을 요구할 때
              <br></br> ⓷ 재적인원 3분의 1 이상이 회의의 목적을 제시하여 소집을
              요구할 때<br></br> 2. 총회 소집권자가 궐위하거나, 소집을
              기피함으로서 7일 이상 총회의 소집이 불가능할 때에는 재적이사
              과반수 또는 재적 회원 3분의 1 이상의 찬성으로 총회는 출석이사 중
              추천으로 의장을 대행한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="23">
            <Accordion.Header>제 24 조 (의결정족수)</Accordion.Header>
            <Accordion.Body>
              1. 총회는 정회원 과반수의 출석으로 개의하고 출석회원 과반수의
              찬성으로 의결한다.<br></br> 2. 총회의 의결권은 총회에 참석하는
              다른 회원에게 서면으로 위임할 수 있다. 이 경우 위임장은 총회 개시
              전까지 의장에게 제출하여야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="24">
            <Accordion.Header>제 25 조 (총회의 기능)</Accordion.Header>
            <Accordion.Body>
              총회는 다음의 사항을 의결한다.<br></br> 1. 임원의 선출 및 해임에
              관한 사항<br></br> 2. 본원의 해산 및 정관변경에 관한 사항<br></br>{" "}
              3. 기본재산의 처분 및 취득과 자금의 차입에 관한 사항<br></br> 4.
              예산 및 결산의 승인<br></br> 5. 사업계획의 승인<br></br> 6. 기타
              본원의 운영상 중요하다고 이사장이 부의하는 사항
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="25">
            <Accordion.Header>제 26 조 (총회 의결 제척사유)</Accordion.Header>
            <Accordion.Body>
              회원은 다음 각 1호에 해당하는 때에는 그 의결에 참여하지 못한다.
              <br></br>
              1. 임원의 선출 및 해임에 있어 자신에 관한 사항을 의결할 때
              <br></br> 2. 금전 및 재산의 수수 또는 소송에 관련되는 사항으로서
              자신과 본원의 이해가 상반될 때
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="26">
            <Accordion.Header>제 27 조 (이사회의 구성)</Accordion.Header>
            <Accordion.Body>
              이사회는 이사장, 원장, 이사로 구성되며 이사장이 의장이 된다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="27">
            <Accordion.Header>제 28 조 (구분 및 소집)</Accordion.Header>
            <Accordion.Body>
              1. 이사회는 정기이사회와 임시이사회로 구분하며, 이사장이 이를
              소집한다.<br></br> 2. 정기이사회는 회계연도 1월 전까지 소집하며,
              임시이사회는 이사장이 필요하다고 인정할 때 소집한다.<br></br> 3.
              이사회의 소집은 이사장이 회의 안건, 일시 장소 등을 명기하여 회의
              개시 7일 전까지 문서로 각 이사 및 감사에게 통지하여야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="28">
            <Accordion.Header>제 29 조 (이사회소집의 특례)</Accordion.Header>
            <Accordion.Body>
              1. 이사장은 다음 각호의 1에 해당하는 소집 요구가 있을 때에는 그
              소집요구일로부터 20일 이내에 이사회를 소집하여야 한다.<br></br> ⓵
              재적 이사 과반수가 회의의 목적을 제시하여 소집을 요구할 때
              <br></br> ⓶ 18조 제3항 제4호의 규정에 의하여 감사가 소집을 요구할
              때<br></br> 2. 이사회 소집권자가 궐위되거나 이를 기피함으로써 7일
              이상 이사회소집이 불가능할 때에는 재적이사 과반수의 찬성으로
              이사회를 소집할 수 있다.<br></br> 3. 제2항의 규정에 의한 이사회는
              출석이사 중에서 추천받아 그 의장을 선출한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="29">
            <Accordion.Header>제 30 조 (서면결의 금지)</Accordion.Header>
            <Accordion.Body>
              이사회는 대면 결의가 원칙이나 예외적으로 서면결의가 가능하다.
              <br></br>
              1. 이사장은 이사회에 부의할 사항 중 경미한 사항 또는 긴급을 요하는
              사항에 있어서 서면으로 의결할 수 있다. 이 경우 이사회에 보고하여야
              한다.<br></br> 2. 제1호 서면결의 사항에 대해서 재적이사 과반수가
              이사회 부의할 것을 요구하면 이사장은 이를 따라야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="30">
            <Accordion.Header>제 31 조 (의결정족수)</Accordion.Header>
            <Accordion.Body>
              1. 이사회는 재적이사 과반수의 출석으로 개의하고 출석 이사 과반수의
              찬성으로 의결한다. 다만, 가부동수인 경우에는 의장이 결정한다.
              <br></br>
              2. 이사회의 의결권은 위임할 수 없다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="31">
            <Accordion.Header>제 32 조 (이사회의 의결 사항)</Accordion.Header>
            <Accordion.Body>
              이사회는 다음의 사항을 심의, 의결한다.<br></br> 1. 업무 집행에
              관한 사항<br></br> 2. 사업계획의 운영에 관한 사항<br></br> 3.
              예산, 결산서의 작성에 관한 사항<br></br> 4. 정관변경에 관한 사항
              <br></br>
              5. 재산관리에 관한 사항<br></br> 6. 회에 부의할 안건의 작성
              <br></br> 7. 총회에서 위임받은 사항<br></br> 8. 정관의 규정에
              의하여 그 권한에 속하는 사항<br></br> 9. 기타 본회의 운영상
              중요하다고 이사장이 부의하는 사항
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="32">
            <Accordion.Header>제 33 조 (재산의 구분)</Accordion.Header>
            <Accordion.Body>
              1. 본원의 재산은 다음과 같이 기본재산과 보통재산으로 구분한다.
              <br></br> ⓵ 기본재산은 본원 설립 시 그 설립자가 출연한 재산과
              이사회에서 기본재산으로 정한 재산으로 하며, 그 목록은 별지 1과
              같다.<br></br> ⓶ 보통재산은 기본재산 이외의 재산으로 한다.
              <br></br> 2. 본회의 기본재산은 연1회 그 목록을 작성하여
              문화체육관광부 장관에서 보고 하여야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="33">
            <Accordion.Header>제 34 조 (기본재산의 처분)</Accordion.Header>
            <Accordion.Body>
              1. 본원의 기본재산을 매도·증여·임대·교환 또는 담보로 제공하고자
              할때에는 총회의 의결을 거쳐 제43조의 정관변경 절차를 거쳐야 한다.
              <br></br>
              2. 본원의 의무의 부담, 권리의 포기를 하고자 할 때에는 총회의
              의결을 거쳐야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="34">
            <Accordion.Header>제 35 조 (수입금)</Accordion.Header>
            <Accordion.Body>
              본원의 수입금은 회원의 회비 및 기타 수입으로 충당한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="35">
            <Accordion.Header>제 36 조 (회계연도)</Accordion.Header>
            <Accordion.Body>
              본회의 회계연도는 정부의 회계연도와 같이 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="36">
            <Accordion.Header>제 37 조 (예산편성)</Accordion.Header>
            <Accordion.Body>
              본원의 세입, 세출 예산은 매 회계연도 개시 1월 전까지 편성하여
              이사회의 의결을 거쳐 총회의 승인을 얻어야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="37">
            <Accordion.Header>제 38 조 (결산)</Accordion.Header>
            <Accordion.Body>
              본원은 매 회계연도 종료 후 2월 이내에 결산서를 작성하여 이사회의
              의결을 거쳐 총회의 승인을 얻어야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="38">
            <Accordion.Header>제 39 조 (회계감사)</Accordion.Header>
            <Accordion.Body>
              감사는 회계감사를 연1회 이상 실시하여야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="39">
            <Accordion.Header>제 40 조 (임원의 보수)</Accordion.Header>
            <Accordion.Body>
              사업의 운영을 전담하는 임원에 대해서는 보수를 지급하지 아니한다.
              다만, 업무수행에 필요한 실비는 지급할 수 있다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="40">
            <Accordion.Header>제 41 조 (사무국)</Accordion.Header>
            <Accordion.Body>
              1. 이사장의 지시를 받아 본원의 사무를 처리하기 위하여 사무국을
              둔다.<br></br> 2. 사무국에는 사무국장 1인과 필요한 직원을 둘 수
              있다.<br></br> 3. 사무국장은 이사회의 의결을 거쳐 이사장이
              임명한다.<br></br> 4. 사무국의 조직 및 운영에 관한 사항은 이사회의
              의결을 거쳐 별도로 정한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="41">
            <Accordion.Header>제 42 조 (법인해산)</Accordion.Header>
            <Accordion.Body>
              1. 본원이 해산하고자 할 때에는 총회에서 재적인원 3분의 2이상의
              찬성으로 의결하여 해산하고. 그 해산에 관하여
              문화체육관광부장관에게 신고하여야 한다.<br></br> 2. 본원이 해산한
              때의 잔여재산은 총회의 의결을 거쳐 국가·지방자치단체 또는 본원과
              유사한 단체에 기증한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="42">
            <Accordion.Header>제 43 조 (정관변경)</Accordion.Header>
            <Accordion.Body>
              이 정관을 변경하고자 할 때는 총회에서 재적인원 3분의 2 이상의
              찬성으로 의결하여 문화체육관광부 장관의 허가를 받아야 한다.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="43">
            <Accordion.Header>제 44 조 (사업보고)</Accordion.Header>
            <Accordion.Body>
              본원은 매 회계 연도 종료 후 2개월 이내에 다음의 서류를
              문화체육관광부 장관에게 제출한다.<br></br> 1. 익년도 사업계획서 및
              예산서<br></br> 2. 당해연도의 사업실적서 및 수지결산서<br></br> 3.
              당해연도 말의 재산목록, 사업 현황 및 감사 보고서
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="44">
            <Accordion.Header>제 45 조 (규칙제정)</Accordion.Header>
            <Accordion.Body>
              이 정관에 정한 것 외에 본원의 운영에 관하여 필요한 사항은 이사회의
              의결을 거쳐 규칙으로 정한다.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </SidebarLayout>
    </div>
  );
}
